<template>
    <div>
        <h1 style="font-size: 24px; color: black;">广告素材管理</h1>
        <el-tabs type="card" v-model="selectedPositionIndexString" @tab-click="changeIndex" >
            <el-tab-pane v-for="position in this.newPositions"  :name="position.id+''" :key="position.id" :label="position.name">
            </el-tab-pane>
        </el-tabs>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            
            <el-row  type="flex"  align="middle" >
                <el-col :span="4">
                        <span style="width:70px" > 素材ID：</span>
                        <el-input  placeholder="请输入内容"  v-model="queryMaterialData.id" ></el-input>
                </el-col>
                <el-col :span="4">
                        <span class="margin-left-10" > 状态：</span>
                        <el-select v-model="queryMaterialData.state" placeholder="请选择"  >
                            <el-option v-for="state in states"
                                       :key="state.id"
                                       :label="state.name"
                                       :value="state.id"></el-option>
                        </el-select>
                </el-col>
                <el-col :span="8">
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="exportExcel">导出</el-button>
                    <el-button type="success" @click="showDetails('新增素材')">新增</el-button>   
                    <el-upload :action="upload()" :headers="headers"
                                   :on-success="handleZipSuccess"
                                   :before-upload="beforeZipUpload"
                                   :show-file-list="false"
                                   v-loading.fullscreen.lock="loading"
                                   ref="upload">
                            <el-button  type="success" class="margin-left-10">批量上传</el-button>
                     </el-upload>
                </el-col>
            </el-row>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="materials"
                      style="width: 100%"
                      border>
                <el-table-column label="素材ID" prop="id" align="center"></el-table-column>
                <el-table-column label="素材类型" prop="materialType.name" align="center"></el-table-column>
                <el-table-column label="素材名称" prop="materialName" align="center"></el-table-column>
                <el-table-column label="版块名称"   align="center" v-if="selectedPositionIndex !==0">
                    <template slot-scope="scope" v-if="selectedPositionIndex !==0">
                        {{ scope.row.plateName.name}}
                    </template>
                </el-table-column>

                <el-table-column label="尺寸大小"   align="center">
                    <template slot-scope="scope">
                        {{ (scope.row.materialSize / 1000).toFixed(2) }}kb
                    </template>
                </el-table-column>
                <el-table-column label="素材图"  align="center">
                    <template slot-scope="scope">
                            <img :src="VUE_APP_CDN_URL+scope.row.materialPicture" width="80px" height="80px" />
                    </template>
                </el-table-column>
                <el-table-column label="落地页类型" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.materialJumpType===0 ">html链接(浏览器)</div>
                        <div v-if="scope.row.materialJumpType===1" >Android下载</div>
                        <div v-if="scope.row.materialJumpType===2" >App拉起链接</div>
                        <div v-if="scope.row.materialJumpType===3" >html链接(应用内)</div>
                    </template>
                </el-table-column>
                <el-table-column label="落地页连接" prop="materialJumpUrl" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="更新时间"  align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.dtUpdate,"yyyy-MM-DD HH:mm:ss")}}
                    </template>
                </el-table-column>
                <el-table-column label="排序" align="center">
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0" style="width: 120px" v-model="scope.row.rank"  @change="update(scope.row)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.state"
                                   :active-value="1"
                                   :inactive-value="0"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="update(scope.row)"
                                 >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button type="text" @click="showDetails('编辑版本',scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="materialEditForm" label-width="150px">
                    <el-form-item label="素材名称:" >
                        <el-input  style="width: 300px" type="text" v-model="materialEditForm.materialName"></el-input>
                    </el-form-item>
                    <el-form-item label="版块名称:"  v-if="selectedPositionIndex ===1">
                        <el-select  v-model="materialEditForm.plateName" v-if="selectedPositionIndex ===1">
                            <el-option
                                    v-for="item in plates"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="素材类型:" >
                        <el-select  v-model="materialEditForm.materialType">
                            <el-option
                                    v-for="item in materialTypes"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="item.id">
                            </el-option>
                        </el-select>
                   </el-form-item>
                    <el-form-item label="素材上传 :" >
                        <el-upload :headers="headers"
                                   class="avatar-uploader"
                                   :action="uploadURL"
                                   :show-file-list="false"
                                   :on-success="handleRISuccess"
                                   :before-upload="function (file) { return beforeAvatarUpload(file, 'picture')}"
                                   @click="uploadIcon">
                            <img v-if="materialEditForm.materialPicture " :src="VUE_APP_CDN_URL+materialEditForm.materialPicture" class="avatar">
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="视频上传 :" v-if="selectedPositionIndex ===0">
                        <el-upload
                                v-if="selectedPositionIndex ===0"
                                class="avatar-uploader "
                                :action="uploadURL"
                                :headers="headers"
                                :show-file-list="false"
                                :on-success="handleVideoSuccess"
                                :before-upload="beforeUploadVideo">
                            <video v-if="materialEditForm.materialVideo"  :src="VUE_APP_CDN_URL+materialEditForm.materialVideo"  class="avatar1" controls="controls"></video>
                            <i v-else class="el-icon-video-camera-solid avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="素材大小:" >
                        {{ (materialEditForm.materialSize / 1000).toFixed(2) }}kb
                    </el-form-item>
                    <el-form-item label="落地页类型:" >
                        <el-radio-group  v-model="materialEditForm.materialJumpType">
                            <el-radio :label="0">html链接(浏览器)</el-radio>
                            <el-radio :label="1">Android下载</el-radio>
                            <el-radio :label="2">App拉起链接</el-radio>
                            <el-radio :label="3">html链接(应用内)</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="广告标题:" >
                        <el-input  style="width: 300px" type="text" v-model="materialEditForm.materialTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="广告简述:" >
                        <el-input  style="width: 300px" type="text" v-model="materialEditForm.materialDescription"></el-input>
                    </el-form-item>
                    <el-form-item label="落地页地址:" >
                        <el-input  style="width: 300px" type="text" v-model="materialEditForm.materialJumpUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="拉起失败地址:" v-if="materialEditForm.materialJumpType===2 ">
                        <el-input  style="width: 300px" type="text" v-model="materialEditForm.startFailedUrl"></el-input>
                    </el-form-item>

                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirm">确 定</el-button>
                        <el-button type="info" @click="cancel">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        allPosition,
        searchAdMaterial,
        saveAdMaterial,
        allMaterialType,
        allPlateName,
        downloadData,
        gameUpload,
    } from "@/http/api";
    import store from '@/store'
    import utils from '@/utils'
    export default {
        name: "AdMaterialList",
        data(){
            return {
                loading: false,
                dialogVisible: false,
                dialogTitle :'',
                materials:[],
                plates:[],
                headers:{},
                uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
                VUE_APP_BASE_URL:null,
                VUE_APP_CDN_URL:null,
                materialTypes:[],
                newPositions:[],
                selectedMaterialPosition: 0,
                selectedPositionIndexString: store.state.adMaterial.selectedPositionIndex+"",
                selectedPositionIndex: store.state.adMaterial.selectedPositionIndex,
                materialEditForm: {
                    "id": 0,
                    "materialPosition": 0,
                    "plateName":0,
                    "materialName":'',
                    "materialSize": 0,
                    "materialType": 0,
                    "materialPicture": '',
                    "materialVideo": '',
                    "materialJumpType": 0,
                    "materialJumpUrl":'',
                    "materialTitle":'',
                    "startFailedUrl":'',
                    "materialDescription":'',
                    "rank":0,
                    "state":0
                },
                queryMaterialData:{
                    "id":null,
                    "state":-1,
                    "materialPosition":0
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                states: [
                    {id:-1,name:'全部'},
                    {id:0,name:'关闭'},
                    {id:1,name:'开启'}
                ],
                messageDialog: {
                    show: false,
                    title: null,
                    message: null
                },
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            confirm(){
                saveAdMaterial(this.materialEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.search();
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            search(){
                searchAdMaterial(this.queryMaterialData).then(resp=>{
                    this.materials=resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements;
                })
            },
            handleZipSuccess(data) {
                this.loading = false;
                let title;
                if (data.status === 0) {
                    title = "温馨提示";
                } else {
                    title = "错误提示";
                }
                this.messageDialogFun(true, title, data.msg);
                this.search();
            },
            beforeZipUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.zip';
                const size = data.size < 1024 * 1024 * 100;
                if (!type) {
                    this.$message.error('上传zip只能是zip格式!');
                }
                if (!size) {
                    this.$message.error('上传zip大小不能超过100m!');
                }
                let b = type && size;
                if (b) {
                    this.loading = true;
                    this.messageDialogFun(true, '温馨提示', '上传中，请稍候');
                }
                return type && size;
            },
            messageDialogFun(show, title, message) {
                this.messageDialog.show = show;
                this.messageDialog.title = title;
                this.messageDialog.message = message;
            },
            showDetails(title, row) {
               allMaterialType().then(resp=>{
                   if (this.selectedPositionIndex ===0){
                       this.materialTypes = resp.data.info.filter(a => a.id === 0);
                   }else{
                       this.materialTypes = resp.data.info.filter(a => a.id === 2);
                   }
                    });
                allPlateName().then(resp=>{
                    this.plates = resp.data.info;
                });

                if (this.selectedPositionIndex ===0){
                    this.materialEditForm={
                        "id": 0,
                        "plateName":0,
                        "materialPosition":0,
                        "materialName":'',
                        "materialSize": 0,
                        "materialType": 0,
                        "materialPicture": '',
                        "materialJumpType": 0,
                        "materialJumpUrl":'',
                        "materialTitle":'',
                        "startFailedUrl":'',
                        "materialDescription":'',
                        "materialVideo": '',
                        "rank":0,
                        "state":0
                    };
                }else{
                    this.materialEditForm={
                        "id": 0,
                        "plateName":0,
                        "materialPosition":this.selectedPositionIndex,
                        "materialName":'',
                        "materialSize": 0,
                        "materialType": 2,
                        "materialPicture": '',
                        "materialJumpType": 0,
                        "materialJumpUrl":'',
                        "startFailedUrl":'',
                        "materialTitle":'',
                        "materialDescription":'',
                        "materialVideo": '',
                        "rank":0,
                        "state":0
                    };
                }


                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.materialEditForm={
                        "id": row.id,
                        "materialPosition": row.materialPosition.id,
                        "plateName":row.plateName.id,
                        "materialName":row.materialName,
                        "materialSize": row.materialSize,
                        "materialType": row.materialType.id,
                        "materialPicture": row.materialPicture,
                        "materialJumpType": row.materialJumpType,
                        "materialJumpUrl":row.materialJumpUrl,
                        "materialVideo": row.materialVideo,
                        "materialTitle":row.materialTitle,
                        "startFailedUrl":row.startFailedUrl,
                        "materialDescription":row.materialDescription,
                        "rank":row.rank,
                        "state":row.state
                    };
                }
            },
            update(row){
                this.materialEditForm={
                    "id": row.id,
                    "materialPosition": row.materialPosition.id,
                    "plateName":row.plateName.id,
                    "materialName":row.materialName,
                    "materialSize": row.materialSize,
                    "materialType": row.materialType.id,
                    "materialPicture": row.materialPicture,
                    "materialJumpType": row.materialJumpType,
                    "materialJumpUrl":row.materialJumpUrl,
                    "materialTitle":row.materialTitle,
                    "materialVideo": row.materialVideo,
                    "startFailedUrl":row.startFailedUrl,
                    "materialDescription":row.materialDescription,
                    "rank":row.rank,
                    "state":row.state
                };
                saveAdMaterial(this.materialEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.search();
                    }
                })
            },
            upload() {
                return this.VUE_APP_BASE_URL + 'adMaterial/upload';
            },
            handleRISuccess(response){
                this.materialEditForm.materialPicture=response.info;
            },
            handleVideoSuccess(response){
                this.materialEditForm.materialVideo=response.info;
            },
            beforeAvatarUpload(file,field) {
                if(field==='picture'){
                    this.materialEditForm.materialSize=file.size;
                }
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            beforeUploadVideo(file){
                const isVideo = file.type === 'video/mp4' || file.type === 'video/avi' || file.type === 'video/wmv';
                const  isLt5M = file.size/1024/1024<5;
                if (!isLt5M){
                    this.$message.error('上传视频不能超过5Mb')
                }
                if (!isVideo){
                    this.$message.error('上传视频是能是mp4，avi,wmv格式')
                }
                return isLt5M && isVideo;
            },
            uploadIcon(){
                let func = gameUpload;
                func().then().catch(function () {
                })
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '素材列表.xlsx';
                downloadData(
                    '/adMaterial/exportExcel',
                    null,
                    fileName
                )
            },
            changeIndex: function(tab){
                this.$store.commit('changeSelectedPositionIndex', tab.name);
                this.selectedPositionIndex = parseInt(tab.name);
                this.selectedMaterialPosition = 0;
                this.materialEditForm.materialPosition = parseInt(tab.name);
                this.queryMaterialData.materialPosition = parseInt(tab.name);
                this.queryMaterialData.id = null;
                searchAdMaterial(this.queryMaterialData).then(resp=>{
                    this.materials=resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements;
             })
             }
        },
        created () {
            allPosition().then(resp=>{
                this.headers ={Authorization : this.$store.state.user.token};
                this.newPositions = resp.data.info;
                this.changeIndex({name: this.selectedPositionIndex+''})
            });
        },
        mounted() {
            this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }

    }
</script>

<style scoped>

</style>
